<template>
  <v-card outlined>
    <slot></slot>
  </v-card>
</template>

<script>
export default {};
</script>
